// Websafe Fonts that should be available on all devices
export default [
  'Helvetica',
  'Times New Roman',
  'Courier',
  'Georgia',
  'serif',
  'Verdana',
  'sans-serif',
  'Lucida Console',
  'monospace',
  'Tahoma',
  'Trebuchet MS',
  'Garamond',
  'Brush Script MT',
];